import { render } from "./ScorecardsKpiDialog.vue?vue&type=template&id=5667260c&scoped=true&ts=true"
import script from "./ScorecardsKpiDialog.vue?vue&type=script&lang=ts"
export * from "./ScorecardsKpiDialog.vue?vue&type=script&lang=ts"

import "./ScorecardsKpiDialog.vue?vue&type=style&index=0&id=5667260c&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5667260c"]])

export default __exports__